import { Component, Input, OnInit } from '@angular/core';
import { SearchByListParameter } from '../../../../../../Model/Dto/SearchByListParameter';
import { CatalogFilter } from '../../../../../../Model/exportParameter/CatalogFilter';
import { ExportParameter } from '../../../../../../Model/exportParameter/ExportParameter';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'searchByListFilter',
    templateUrl: './searchByListFilter.component.html',
    styleUrls: ['./searchByListFilter.component.css'],
    standalone: false
})
export class SearchByListFilterComponent implements OnInit {
  @Input() exportParameter: ExportParameter;


  searchValues = ['SUPPLIER_PID', 'SUPPLIER_ALT_PID', 'INTERNATIONAL_PID', 'MANUFACTURER_NAME', 'PID', 'MANUFACTURER_PID'];

  constructor(
      public translate: TranslateService) {
    this.onValueChanged = this.onValueChanged.bind(this);
    this.getSearchValueDisplayExpr = this.getSearchValueDisplayExpr.bind(this);

  }

  ngOnInit(): void {

  }

  get parameter(): SearchByListParameter {
    if (!this.exportParameter.searchByListParameter)
      this.exportParameter.searchByListParameter = new CatalogFilter<SearchByListParameter>(new SearchByListParameter());
    if (this.exportParameter.searchByListParameter.filterKey == null)
      this.exportParameter.searchByListParameter.filterKey = new SearchByListParameter();
    if (this.exportParameter.searchByListFilterAdds == null)
      this.exportParameter.searchByListFilterAdds = false;
    if (this.exportParameter.searchByListParameter.filterKey.key == null || this.exportParameter.searchByListParameter.filterKey.key == "")
      this.exportParameter.searchByListParameter.filterKey.key = this.searchValues[0]

    return this.exportParameter.searchByListParameter.filterKey;
  }

  set parameter(value: SearchByListParameter) {
    this.exportParameter.searchByListParameter.filterKey = value
  }

  getSearchValueDisplayExpr(item) {
    if (!item) {
      return '';
    }

    return this.translate.instant(item);
  }

  onValueChanged(e) {
    let text = e.value;
    this.parameter.list = this.formatListIgnoreSpace(text);
  }

  formatListIgnoreSpace(value) {
    var tmp: string = value;
    tmp = tmp.split(";").join("\n");
    tmp = tmp.split("\r").join("\n");
    tmp = tmp.split(",").join("\n");
    while (tmp.includes("\n\n")) {
      tmp = tmp.replace("\n\n", "\n");
    }
    if (tmp.substr(0, 1) == "\n") {
      tmp = tmp.substr(1);
    }
    if (tmp.substr(-1, 1) == "\n") {
      tmp = tmp.substr(0, tmp.length - 1);
    }
    tmp = tmp.split("\n").map(row => row.trim()).join("\n");
    return tmp;
  }

}
